import { Button } from '@/components/ui/button'
import sb from '@/utils/sb';
import { type LoaderFunctionArgs, redirect, useLoaderData } from 'react-router'

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const supabase = sb;

  const { data, error } = await supabase.auth.getUser()
  if (error || !data?.user) {
    return redirect('/s_auth/login')
  }

  return data
}

export default function ProtectedPage() {
  let data = useLoaderData<typeof loader>()

  return (
    <div className="flex items-center justify-center h-screen gap-2">
      <p>
        您好 <span className="text-primary font-semibold">{data.user.email}</span>
      </p>
      <a href="/s_auth/logout">
        <Button>退出登录</Button>
      </a>
      <a href="/">
        <Button>跳转首页</Button>
      </a>
    </div>
  )
}
